import { useFetch } from "matsuri-hooks"
import { RankPreview } from "@/model/rankDashboard"
import { rankDashboardApiUrl } from "@/utils/urls"

export const useRankPreview = (workerId: string) =>
    useFetch<RankPreview>(rankDashboardApiUrl(workerId), {
        swrConfig: { revalidateOnFocus: false }
    })
